import React from 'react'

const TwitterIcon = ({
  width = 24,
  height = width,
  mode = 'whiteOnBlue',
  ...props
}) =>
  mode === 'whiteOnBlue' ? (
    <svg
      width={width}
      height={height}
      viewBox="0 0 510 510"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M459 0H51C23 0 0 23 0 51v408c0 28 23 51 51 51h408c28 0 51-23 51-51V51c0-28-23-51-51-51zm-59 186c-2 117-76 199-188 204-46 3-79-13-110-30 33 5 77-8 99-28-33-3-53-21-63-49 10 3 20 0 28 0-31-10-51-28-54-69 8 5 18 8 28 8-23-13-38-61-20-92 33 36 74 66 140 71-18-71 79-109 117-61 18-2 31-10 44-15-5 18-16 28-28 38 12-2 25-5 35-10-2 13-15 23-28 33z"
        fill="#47A1EB"
      />
    </svg>
  ) : (
    <svg viewBox="0 0 400 400" {...props} width={width} height={height}>
      <path fill="none" d="M0 0h400v400H0z" />
      <path
        d="M153.62 301.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.36 104.36 0 0 0 325 122.47a102.38 102.38 0 0 1-29.46 8.07 51.47 51.47 0 0 0 22.55-28.37 102.79 102.79 0 0 1-32.57 12.45 51.34 51.34 0 0 0-87.41 46.78A145.62 145.62 0 0 1 92.4 107.81a51.33 51.33 0 0 0 15.88 68.47A50.91 50.91 0 0 1 85 169.86v.65a51.31 51.31 0 0 0 41.15 50.28 51.21 51.21 0 0 1-23.16.88 51.35 51.35 0 0 0 47.92 35.62 102.92 102.92 0 0 1-63.7 22 104.41 104.41 0 0 1-12.21-.74 145.21 145.21 0 0 0 78.62 23"
        fill="#1da1f2"
      />
    </svg>
  )

export { TwitterIcon }
export default TwitterIcon
